<template>
  <b-modal :title="modal?.title"
           :modelValue="modal !== null"
           body-class="d-none"
           footer-class="border-top-0 d-flex justify-content-between"
           @update:modelValue="$event === false && (modal = null)">
    <template #footer>
      <button type="button" @click="modal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ modal?.cancelTitle ?? helper.trans('button.cancel')  }}
      </button>
      <LoaderWrapper ref="loader" :zoom="0.5">
        <button type="button" @click="onOkClick()" class="btn btn-outline-danger btn-sm text-capitalize-first">
          {{ modal?.okTitle ?? helper.trans('button.ok') }}
        </button>
      </LoaderWrapper>

    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, ref} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {helper} from "@/service/CommonHelper";

export interface ConfirmModalProps {
  title: string;
  okTitle: string|null,
  cancelTitle: string|null,
  onOkClick(): void
}

export default defineComponent({
  components: {
    BModal,
    LoaderWrapper
  },
  setup() {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      modal: null as ConfirmModalProps|null
    });

    const show = (props: ConfirmModalProps) => {
      state.modal = props
    }

    const onOkClick = async () => {
      if (!state.modal) {
        return;
      }

      loader.value?.show()
      try {
        await state.modal.onOkClick();
      } finally {
        loader.value?.hide()
      }

      state.modal = null;
    }

    return {
      ...toRefs(state),
      onOkClick,
      show,
      loader,
      helper
    }
  }
})
</script>
